module.exports = __webpack_public_path__ + "img/20201101_132044.62188e60.jpg";